import { inject } from '@angular/core';
import { ActivatedRouteSnapshot, CanActivateFn, Router } from '@angular/router';
import { of } from 'rxjs';
import { catchError, map, take } from 'rxjs/operators';
import { ApiService } from '../services/api.service';

export const invitationGuard: CanActivateFn = (route: ActivatedRouteSnapshot) => {
  const apiService = inject(ApiService);
  const router = inject(Router);

  const token = route.queryParams['token'];

  if (!token) {
    return of(true);
  }

  return apiService.validateInvitationToken(token).pipe(
    take(1),
    map((res) => (res && res.isValid ? true : router.createUrlTree(['/invitation-expired']))),
    catchError((err) => {
      console.error('Error validating token in guard:', err);
      return of(router.createUrlTree(['/invitation-expired']));
    })
  );
};
